"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CSV_DECIMAL_SEPARATOR = exports.DEVICE_ID_COOKIE_FIELD = exports.DEFAULT_COMPANY_TIMEZONE = exports.PER_DIEM_DINNER_RATE = exports.PER_DIEM_LUNCH_RATE = exports.PER_DIEM_BREAKFAST_RATE = exports.PASSWORD_MIN_ALLOWED_LENGTH = exports.supportedInvoiceFormats = exports.supportedImageInvoiceFormats = exports.DEFAULT_COMMENT_SPLIT_SYMBOL = exports.SortEnum = exports.DEFAULT_DEBIT_CARD_LIMIT_BUFFER = exports.TEN_BILLION = exports.ONE_HUNDRED_MILLION = exports.vendorRecommendations = exports.allowedParsingDateFormats = exports.CalculationIntervals = exports.CurrencySymbol = exports.BudgetPeriods = void 0;
const currency_enum_1 = require("../models/common/currency.enum");
const userSettings_interface_1 = require("../models/user/userSettings.interface");
const recommendationString_enum_1 = require("../models/vendor/recommendationString.enum");
exports.BudgetPeriods = {
    0: "Monthly",
    1: "Quarterly",
    2: "Yearly",
};
exports.CurrencySymbol = {
    [currency_enum_1.CurrencyEnum.USD]: "$",
    [currency_enum_1.CurrencyEnum.EUR]: "€",
    [currency_enum_1.CurrencyEnum.HUF]: "Ft",
};
exports.CalculationIntervals = {
    0: "Current month",
    1: "Current year",
    2: "All times",
};
exports.allowedParsingDateFormats = [
    // German format
    "DD.MM.YYYY",
    "D.M.YYYY",
    "D.MM.YYYY",
    "DD.M.YYYY",
    "DD. MM. YYYY",
    "DD. M. YYYY",
    "D. MM. YYYY",
    "DD. MM. YY",
    "D. MM. YY",
    "DD. M. YY",
    "D. M. YYYY",
    "DD.MM.YY",
    "YYYY-MM-DD",
    "YYYY-M-D",
    "YYYY-MM-D",
    "YYYY-M-DD",
    "DD-MM-YYYY",
    "DD-M-YYYY",
    "D-MM-YYYY",
    "D-M-YYYY",
    "DD/MM/YYYY",
    "D/M/YYYY",
    "DD/M/YYYY",
    "D/MM/YYYY",
    "DD/MM/YY",
    "D/M/YY",
    "DD/M/YY",
    "D/MM/YY",
    // US format
    // 'MM/DD/YYYY',
    // 'M/D/YYYY',
    // 'MM/D/YYYY',
    // 'M/DD/YYYY',
    // 'MM/DD/YY',
    // 'M/D/YY',
    // 'MM/D/YY',
    // 'M/DD/YY',
    // Japanese / Hungarian format
    "YYYY.MM.DD.",
    "YYYY.MM.DD",
    "YYYY. MM. DD.",
    "YYYY. MM. DD",
];
exports.vendorRecommendations = Object.values(recommendationString_enum_1.RecommendationStringEnum);
exports.ONE_HUNDRED_MILLION = 100000000;
exports.TEN_BILLION = 10000000000;
/**
 * In percent.
 */
exports.DEFAULT_DEBIT_CARD_LIMIT_BUFFER = 3;
var SortEnum;
(function (SortEnum) {
    SortEnum["ASC"] = "asc";
    SortEnum["DESC"] = "desc";
})(SortEnum = exports.SortEnum || (exports.SortEnum = {}));
exports.DEFAULT_COMMENT_SPLIT_SYMBOL = ".";
exports.supportedImageInvoiceFormats = [".jpg", ".jpeg", ".png"];
exports.supportedInvoiceFormats = [...exports.supportedImageInvoiceFormats, ".pdf"];
exports.PASSWORD_MIN_ALLOWED_LENGTH = 8;
// TODO FA-161: Refactor and let these values be provided by the backend and store them in redux
exports.PER_DIEM_BREAKFAST_RATE = 0.2;
exports.PER_DIEM_LUNCH_RATE = 0.4;
exports.PER_DIEM_DINNER_RATE = 0.4;
exports.DEFAULT_COMPANY_TIMEZONE = "Europe/Berlin";
exports.DEVICE_ID_COOKIE_FIELD = "deviceId";
exports.DEFAULT_CSV_DECIMAL_SEPARATOR = userSettings_interface_1.CsvNumberDecimalSeparatorTypeEnum.COMMA;
